import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";
import { transparentize } from "polished";

export const BodyInnerWrapper = styled.div`
  width: 659px;
  word-wrap:break-word;
  text-overflow: ellipsis;
  @media (max-width: 1150px) {
    width: 95vw;
  }
  .p3-popover.p3-component {
    bottom: 30px;
    height: auto;
    left: 0;
    margin: auto;
    max-width: 1200px;
    position: fixed;
    right: 0;
    width: 80%;
    z-index: 15;
  }
  #poool-widget iframe {
    width: 100%;
  }
`;
export const BodyWrapper = styled.div`
  grid-template-columns: 1fr 300px;
  display: grid;
  margin-top: 1rem;
  column-gap: 1rem;
  @media (max-width: 1150px) {
    grid-template-columns: 1fr;
  }
  li {
    padding: 5px 0;
  }
  a {
    margin-right: 0;
    color: ${({ theme }) => theme.default.color.primary};
    :hover {
      color: ${({ theme }) => transparentize(0.2, theme.default.color.primary)};
      text-decoration: underline;
    }
  }
`;

export const VideoWrapper = styled.div`
  width: 659px;
  margin: 1rem auto;
  position: relative;
  height: 540px;
  @media (max-width: ${defaultBreakpoints.large}) {
    width: 95vw;
    height: 212px;
  }
`;

export const DailyMotionBodyWrapper = styled.div`
  margin: 1rem auto;
  position: relative;
  height: 400px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${defaultBreakpoints.large}) {
    width: 95vw;
    height: 212px;
  }
  p {
    color: ${({ theme }) => theme.default.color.text.medium};
    display: flex;
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    font-size: 15px !important;
  }
`;
